<template>
    <div class="lease" :class="{loading: loading}">
        <div class="list-group" v-if="model.created_at">
            <a href="javascript://void(0)" class="list-group-item" @click="openModal" :class="{loading: loading}">
                <div class="row">
                    <div class="col-xs-12 col-sm-5">
                        <dl class="no-margin">
                            <dt>Apt</dt>
                            <dd>{{model.unit || '-'}}</dd>
                        </dl>
                    </div>

                    <div class="col-xs-12 col-sm-7">
                        <dl class="no-margin">
                            <dt>Roommates</dt>
                            <dd>
                                <ul class="list-unstyled">
                                    <li v-if="roommates.length === 0">-</li>
                                    <li v-for="resident in roommates">
                                        <a :href="'/residents/' + resident.id">
                                            {{resident.fullName}}
                                        </a>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6 col-sm-5">
                        <dl class="no-margin">
                            <dt>Start At</dt>
                            <dd>{{model.start_at || '-'}}</dd>
                        </dl>
                    </div>

                    <div class="col-xs-6 col-sm-7">
                        <dl class="no-margin">
                            <dt>End At</dt>
                            <dd>{{model.end_at || '-'}}</dd>
                        </dl>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6 col-sm-5">
                        <dl class="no-margin">
                            <dt>Move In</dt>
                            <dd>{{model.move_in_at || '-'}}</dd>
                        </dl>
                    </div>

                    <div class="col-xs-6 col-sm-7">
                        <dl class="no-margin">
                            <dt>Move Out</dt>
                            <dd>{{model.move_out_at || '-'}}</dd>
                        </dl>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6 col-sm-5">
                        <dl class="no-margin">
                            <dt>Lease Type</dt>
                            <dd>{{model.lease_type_display || '-'}}</dd>
                        </dl>
                    </div>

                    
                </div>
            </a>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               v-if="model.created_at"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="currentResident.created_at" class="display-block">
                        {{currentResident.fullName}}
                        <span v-if="model.archivedLabel" v-html="model.archivedLabel"></span>
                    </h4>
                    <h4 v-else="Lease {{model.unit}}"></h4>

                    <h5 v-if="currentResident.created_at">Lease {{model.unit}}</h5>

                    <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                </header>

                <div class="row">
                    <div class="col-xs-12 col-sm-5">
                        <dl class="no-margin">
                            <dt>Apt</dt>
                            <dd>{{model.unit || '-'}}</dd>
                        </dl>
                    </div>

                    <div class="col-xs-12 col-sm-7">
                        <dl class="no-margin">
                            <dt>Roommates</dt>
                            <dd>
                                <ul class="list-unstyled">
                                    <li v-if="roommates.length === 0">-</li>
                                    <li v-for="resident in roommates">
                                        <a :href="'/residents/' + resident.id">
                                            {{resident.fullName}}
                                        </a>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6 col-sm-5">
                        <dl class="no-margin">
                            <dt>Start At</dt>
                            <dd>{{model.start_at || '-'}}</dd>
                        </dl>
                    </div>

                    <div class="col-xs-6 col-sm-7">
                        <dl class="no-margin">
                            <dt>End At</dt>
                            <dd>{{model.end_at || '-'}}</dd>
                        </dl>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6 col-sm-5">
                        <dl class="no-margin">
                            <dt>Move In</dt>
                            <dd>{{model.move_in_at || '-'}}</dd>
                        </dl>
                    </div>

                    <div class="col-xs-6 col-sm-7">
                        <dl class="no-margin">
                            <dt>Move Out</dt>
                            <dd>{{model.move_out_at || '-'}}</dd>
                        </dl>
                    </div>
                </div>

                <tabs>
                    <tab title="Edit">
                        <form @submit.prevent="saveModel" accept-charset="UTF-8" novalidate="novalidate"
                              data-vv-scope="lease">
                            <fieldset>
                                <legend>Lease</legend>

                                <div class="row">
                                    <div class="col-sm-6 form-group has-feedback"
                                         :class="{'has-error': errors.has('lease.Lease[start_at]')}">
                                        <label for="lease-start-at">Start At</label>

                                        <input id="lease-start-at"
                                               name="Lease[start_at]"
                                               type="date"
                                               class="form-control"
                                               v-model="model.start_at">

                                        <span v-show="errors.has('lease.Lease[start_at]')" class="help-block">
                                            {{ errors.first('lease.Lease[start_at]') }}
                                        </span>
                                    </div>

                                    <div class="col-sm-6 form-group has-feedback"
                                         :class="{'has-error': errors.has('lease.Lease[end_at]')}">
                                        <label for="lease-end-at">End At</label>

                                        <input id="lease-end-at"
                                               name="lease.Lease[end_at]"
                                               type="date"
                                               class="form-control"
                                               v-model="model.end_at">

                                        <span v-show="errors.has('lease.Lease[end_at]')" class="help-block">
                                            {{ errors.first('lease.Lease[end_at]') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 form-group has-feedback"
                                         :class="{'has-error': errors.has('lease.Lease[move_in_at]')}">
                                        <label for="lease-move-in-at">Move In At</label>

                                        <input id="lease-move-in-at"
                                               name="Lease[move_in_at]"
                                               type="date"
                                               class="form-control"
                                               v-model="model.move_in_at">

                                        <span v-show="errors.has('lease.Lease[move_in_at]')" class="help-block">
                                            {{ errors.first('lease.Lease[move_in_at]') }}
                                        </span>
                                    </div>

                                    <div class="col-sm-6 form-group has-feedback"
                                         :class="{'has-error': errors.has('lease.Lease[move_out_at]')}">
                                        <label for="lease-move-out-at">End At</label>

                                        <input id="lease-move-out-at"
                                               name="lease.Lease[move_out_at]"
                                               type="date"
                                               class="form-control"
                                               v-model="model.move_out_at">

                                        <span v-show="errors.has('lease.Lease[move_out_at]')" class="help-block">
                                            {{ errors.first('lease.Lease[move_out_at]') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 form-group has-feedback"
                                         :class="{'has-error': errors.has('lease.Lease[unit]')}">
                                        <label for="lease-unit">Apt</label>

                                        <input id="lease-unit"
                                               name="Lease[unit]"
                                               type="text"
                                               class="form-control"
                                               v-model="model.unit">

                                        <span v-show="errors.has('lease.Lease[unit]')" class="help-block">
                                            {{ errors.first('lease.Lease[unit]') }}
                                        </span>
                                    </div>
                                    <div class="col-sm-6 form-group has-feedback"
                                         :class="{'has-error': errors.has('lease.Lease[manual_auto_enroll]')}">
                                        <div class="form-group has-feedback"
                                            :class="{'has-error': errors.has('lease.Lease[manual_auto_enroll]')}">
                                            <div class="checkbox">
                                                <label for="manual-auto-enroll">
                                                    <input v-model.boolean="model.manual_auto_enroll"
                                                        type="checkbox"
                                                        id="manual-auto-enroll"
                                                        name="Lease[manual_auto_enroll]">
                                                    <b>Manual Auto Enroll</b>
                                                </label>
                                            </div>
                                        </div>
                                        <span v-show="errors.has('lease.Lease[manual_auto_enroll]')" class="help-block">
                                            {{ errors.first('lease.Lease[manual_auto_enroll]') }}
                                        </span>
                                    </div>





                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-xs-6">
                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="restoreModel"
                                                v-if="model.created_at && model.deleted_at"
                                                :disabled="loading">
                                            <i class="fa fa-refresh" aria-hidden="true"></i>
                                        </button>
                                    </div>

                                    <div class="col-xs-6 form-group pull-right" v-if="!model.deleted_at">
                                        <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </tab>
                    <tab title="Join">
                        <form @submit.prevent="saveResident" accept-charset="UTF-8" novalidate="novalidate"
                              data-vv-scope="resident">

                            <input v-validate="'required'"
                                   v-model="residentId"
                                   name="Resident[id]"
                                   type="hidden"
                                   aria-required="true">

                            <fieldset>
                                <legend>Join</legend>

                                <p class="important">
                                    Join current resident to another resident's lease.
                                </p>

                                <div class="form-group has-feedback"
                                     :class="{'has-error': errors.has('resident.Resident[lease_id]')}">
                                    <auto-complete
                                        @change="setResident"
                                        :query-string="'lease_id=!null&limit=10&project_id=' + model.project_id + '&id=!' + residentId"
                                        class="form-group"
                                        name="Resident[lease_id]"
                                        label="Resident"
                                        search-results-index="Residents"
                                        find-result-index="Resident"
                                        resource-url="/api/residents"
                                        ref="residentAutoComplete">
                                        <template slot-scope="resident" slot="model-display">
                                            {{resident.first_name}} {{resident.last_name}} (Apt: {{resident.lease.unit}})
                                        </template>
                                    </auto-complete>

                                    <span v-show="errors.has('resident.Resident[lease_id]')" class="help-block">
                                        {{ errors.first('resident.Resident[lease_id]') }}
                                    </span>
                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-xs-6 form-group pull-right">
                                        <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </tab>
                </tabs>
            </div>
        </modal>
    </div>
</template>

<script>
    import model from "./mixins/model";

    export default {
        mixins: [ model ],

        props: {
            residentId: {
                required: true,
                type: String
            },
        },

        computed: {
            currentResident(){
                let resident = null;
                if( !_.isEmpty( this.model.residents ) ){
                    resident = _.find( this.model.residents, { id: this.residentId } );
                }

                if( resident ){
                    return resident;
                }

                return {};
            },

            roommates(){
                if( this.model.residents ){
                    return _.filter( this.model.residents, ( resident ) => {
                        return resident.id !== this.residentId;
                    } );
                }

                return [];
            },

            saveValidationKey(){
                return 'lease'
            },

            resourceKey(){
                return 'Lease';
            },

            url(){
                return '/api/leases/' + this.model.id;
            },
        },

        watch: {},

        methods: {
            getModelData(){
                return {
                    lease: {},

                    resident: {
                        lease_id: null
                    },
                };
            },

            setResident( resident_id, resident ){
                this.resident = resident;
            },

            saveResident(){
                return this.$validator.validateAll( 'resident' )
                    .then( ( valid ) => {
                        if( valid ){
                            var promise;
                            this.loading = true;

                            this.beforeSave();

                            return axios.put( '/api/residents/' + this.residentId, {
                                Resident: {
                                    id: this.residentId,
                                    lease_id: this.resident.lease_id
                                }
                            } )
                                .then( ( result ) => {
                                    return this.init();
                                } )
                                .then( () => {
                                    this.$emit( 'afterSave' );
                                    this.closeModal();

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Save Successful',
                                    } );
                                } )
                                .finally( () => {
                                    this.loading = false;
                                } )
                                .catch( ( err ) => {
                                    return this.$root.handleErrors( err, 'resident' );
                                } );
                        }
                    } );
            },

            saveLease(){
                return this.$validator.validateAll( 'newLease' )
                    .then( ( valid ) => {
                        if( valid ){
                            this.loading = true;

                            this.beforeSave();

                            this.lease.project_id = this.model.project_id;

                            return axios.post( '/api/leases', {
                                Lease: this.lease
                            } )
                                .then( ( result ) => {
                                    this.$set( this, 'resident', {
                                        id: this.residentId,
                                        lease_id: result.data.Lease.id
                                    } );

                                    return this.saveResident();
                                } )
                                .then( () => {
                                    this.$emit( 'afterSave' );
                                    this.closeModal();

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Save Successful',
                                    } );
                                } )
                                .finally( () => {
                                    this.loading = false;
                                } )
                                .catch( ( err ) => {
                                    return this.$root.handleErrors( err, 'newLease' );
                                } );
                        }
                    } );
            },
        }
    }
</script>
